import { delay, put, takeEvery } from 'redux-saga/effects';
import * as actions from 'containers/Campaigns/actions';
import { ERROR_MESSAGE_SET } from 'containers/Campaigns/action-types';

function* setErrorMessageSaga({ payload }) {
  if (payload !== '' && payload !== null) {
    yield delay(5000);
    yield put(actions.setErrorMessage(null));
  }
}

export default function* campaignsSagas() {
  yield takeEvery(ERROR_MESSAGE_SET as any, setErrorMessageSaga);
}
